import Link from 'next/link';
import { FC } from 'react';
import { IoCheckmark } from 'react-icons/io5';

import { Box, Group, GroupProps } from '@mantine/core';
import { sort } from 'radash';

import { CompanyProfile } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { useProfileProgress, useProgressItems } from 'components/company-profile/hooks/use-profile-progress';

import cx from './ProgressChecklist.module.scss';

const ProgressChecklist: FC<{ company: CompanyProfile; remainingOnly?: boolean; limit?: number } & GroupProps> = ({
    company,
    remainingOnly,
    limit,
    ...props
}) => {
    const progressItems = useProgressItems(company);
    const { progress } = useProfileProgress(company);

    const isDone = (key: string) => Boolean(progress.find((item) => item.key === key)?.progress);

    const steps = sort(
        progressItems.filter(({ value }) => progress.some((item) => item.key === value)),
        ({ value }) => (isDone(value) ? 1 : 0),
    )
        .filter(({ value }) => !remainingOnly || !isDone(value))
        .slice(0, limit);

    return (
        <Group gap="xs" {...props}>
            {steps.map(({ value, label, href }) => (
                <Box
                    key={value}
                    component={Link}
                    href={href ?? CompanyHelpers.urls.edit(company.slug)}
                    className={cx.step}
                    data-done={isDone(value) || undefined}
                >
                    <Box component="span" className={cx.mark}>
                        {isDone(value) && <IoCheckmark />}
                    </Box>
                    {label}
                </Box>
            ))}
        </Group>
    );
};

export { ProgressChecklist };
